// UrgencyBadge — the canonical pill for a PendingAction's urgency. Shared by
// the pending-actions list and the dashboard grow cards so urgency reads the
// same everywhere. Pass `className` for context-specific layout (e.g.
// `shrink-0` when sitting next to a truncating title).

import type { Urgency } from "@/lib/api/types";

const URGENCY_STYLES: Record<Urgency, string> = {
  HIGH: "bg-red-500/10 text-red-700 dark:text-red-300",
  MED: "bg-amber-500/10 text-amber-700 dark:text-amber-300",
  ROUTINE: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300",
  PARKED: "bg-slate-500/10 text-slate-700 dark:text-slate-300",
};

export function UrgencyBadge({
  urgency,
  className = "",
}: {
  urgency: Urgency;
  className?: string;
}) {
  return (
    <span
      className={
        "inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide " +
        URGENCY_STYLES[urgency] +
        (className ? " " + className : "")
      }
    >
      {urgency}
    </span>
  );
}
